module.exports = __webpack_public_path__ + "static/media/IBULHSGFIN.11e6cdff.txt";